import { UserModel, UserRelationsModel, WorkspaceInfoModel } from '@/services/apis/user/model'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import UserApi from '@/services/apis/user'
import { WorkspaceMemberModel } from '@/services/apis/user/model'
import { LocalBackupStateEnum } from '@/constants/enum'
interface IUserSliceState {
  userRelations: UserRelationsModel[]
  workspaceMember: WorkspaceMemberModel
  userInfo: UserModel
  workspaceInfo: WorkspaceInfoModel
  isLocalBackup: boolean
  isLoadingLocalBackup: boolean
}
const initialState: IUserSliceState = {
  userRelations: [],
  workspaceMember: {} as WorkspaceMemberModel,
  userInfo: {} as UserModel,
  workspaceInfo: {} as WorkspaceInfoModel,
  isLocalBackup: false,
  isLoadingLocalBackup: false,
}

export const getUserRelations = createAsyncThunk('user/getUserRelations', async () => {
  const res = await UserApi.getUserRelations()
  return res
})
export const getWorkspaceMember = createAsyncThunk('user/getWorkspaceMember', async () => {
  const res = await UserApi.getWorkspaceMember()
  return res
})
export const getUserInfo = createAsyncThunk('user/getUserInfo', async () => {
  const res = await UserApi.getUserInfo()
  return res
})
export const getWorkspaceInfo = createAsyncThunk('user/getWorkspaceInfo', async () => {
  const res = await UserApi.getWorkspaceInfo()

  return res
})
const userState = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setIsLocalBackup(state, action) {
      state.isLocalBackup = action.payload === LocalBackupStateEnum.COMPLETE
    },
    setUserDetailInfo(state, action) {
      const userInfo = action.payload
      const permissions = userInfo?.permissions?.filter?.((p: { hold: true }) => p.hold)
      if (userInfo && permissions) {
        userInfo.permissions = permissions
      }
      state.workspaceMember = userInfo
    },
    setEmptyUserInfo(state) {
      state.userInfo = {} as UserModel
    },
    setEmptyUserRelations(state) {
      state.userRelations = []
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getUserRelations.fulfilled, (state, action) => {
        if (action.payload.success) {
          state.userRelations = action.payload.data
        }
      })
      .addCase(getWorkspaceMember.fulfilled, (state, { payload }) => {
        if (payload.success) {
          const userInfo = payload.data
          const permissions = userInfo?.permissions?.filter?.(p => p.hold)
          if (userInfo && permissions) {
            userInfo.permissions = permissions
          }
          state.workspaceMember = userInfo
        }
      })
      .addCase(getUserInfo.fulfilled, (state, { payload }) => {
        if (payload.success) {
          state.userInfo = payload.data
        }
      })
      .addCase(getWorkspaceInfo.pending, (state, action) => {
        state.isLoadingLocalBackup = true
      })
      .addCase(getWorkspaceInfo.fulfilled, (state, { payload }) => {
        if (payload.success) {
          state.workspaceInfo = payload.data
          if (typeof payload.data.backupState === 'number') {
            state.isLoadingLocalBackup = payload.data.backupState === LocalBackupStateEnum.COMPLETE
          }
          state.isLoadingLocalBackup = false
        }
      })
      .addCase(getWorkspaceInfo.rejected, (state, { payload }) => {
        state.isLoadingLocalBackup = false
      })
  },
})
export const { setIsLocalBackup, setUserDetailInfo, setEmptyUserInfo, setEmptyUserRelations } =
  userState.actions
export default userState.reducer
